<!-- eslint-disable no-console -->
<template>
  <div class="wrapper">
    <img class="model" src="@/assets/20231212/m_1.jpg" />
    <div class="numberModel">
      <div class="item">
        <img class="icon" src="@/assets/20231212/icon_1.png" alt="" />
        <div class="btnGroup">
          <div class="number">
            <span>报名成功</span>
            <div>{{ signUpNum }}/<span>1个</span></div>
          </div>
          <div class="btn" @click="goSignUp"></div>
        </div>
      </div>
      <div class="item">
        <img class="icon" src="@/assets/20231212/icon_2.png" alt="" />
        <div class="btnGroup">
          <div class="number">
            <span>获得抽金条资格</span>
            <div>{{ lotteryNum }}<span>次</span></div>
          </div>
          <div class="btn btn_2" @click="goScanCode"></div>
        </div>
      </div>
    </div>
    <div class="signUp"></div>
    <div class="form" id="form">
      <van-form>
        <div class="label">您的姓名<span style="color: #ff0035">*</span></div>
        <van-field
          v-model.trim="form.name"
          placeholder="请输入您的姓名"
          :maxlength="10"
          @focus="
            InputFocus({
              input_Label: '姓名',
              formpage_name: formName,
              input_value: form.name,
            })
          "
          @blur="
            InputBlur({
              input_Label: '姓名',
              formpage_name: formName,
              input_value: form.name,
            })
          "
        />
        <div class="label">您的电话<span style="color: #ff0035">*</span></div>
        <van-field
          v-model.trim="form.telphone"
          placeholder="请输入手机号码"
          :maxlength="11"
          @focus="
            InputFocus({
              input_Label: '手机号码',
              formpage_name: formName,
              input_value: form.telphone,
            })
          "
          @blur="
            InputBlur({
              input_Label: '手机号码',
              formpage_name: formName,
              input_value: form.telphone,
            })
          "
        />
        <div class="label">您的验证码<span style="color: #ff0035">*</span></div>
        <van-field
          class="smsCodeBtn"
          v-model.trim="form.codes"
          center
          clearable
          placeholder="请输入验证码"
          :maxlength="6"
          @focus="
            InputFocus({
              input_Label: '短信验证码',
              formpage_name: formName,
              input_value: form.codes,
            })
          "
          @blur="
            InputBlur({
              input_Label: '短信验证码',
              formpage_name: formName,
              input_value: form.codes,
            })
          "
        >
          <template #button>
            <van-button
              style="color: #000"
              size="mini"
              :disabled="isSend"
              type="info"
              @click="sendSms"
              >{{ isSend ? `${num}s` : smsText }}</van-button
            >
          </template>
        </van-field>
        <div class="label">
          您的所在地区（预约就近门店体验）<span style="color: #ff0035">*</span>
        </div>
        <van-field
          readonly
          clickable
          name="area"
          :value="form.fy_location"
          placeholder="请选择所在地区"
          @click="showArea = true"
          @focus="
            InputFocus({
              input_Label: '所在地区',
              formpage_name: formName,
              input_value: form.fy_location,
            })
          "
        />
        <van-popup v-model="showArea" position="bottom">
          <van-area
            :area-list="areaList"
            @confirm="onConfirm"
            @cancel="showArea = false"
          />
        </van-popup>
        <!-- <div class="protect">
          <van-checkbox v-model="checked"
            ><span class="label"
              >勾选表示同意
              <b
                class="label"
                @click.stop="
                  () => {
                    show = true;
                  }
                "
                >《个人信息授权与保护声明》</b
              >
            </span></van-checkbox
          >
        </div> -->
        <div class="bg-btn">
          <van-button
            block
            :round="round"
            type="info"
            @click="onSubmit"
            data-sensors-click
            name="submit-click"
          ></van-button>
        </div>
      </van-form>
    </div>
    <div>
      <img class="model" src="@/assets/20231212/m_5.jpg" />
      <img class="model" src="@/assets/20231212/m_6.jpg" />
      <img class="model" src="@/assets/20231212/m_7.jpg" />
      <img class="model" src="@/assets/20231212/m_8.jpg" />
    </div>
  </div>
</template>

<script>
import { areaList } from "@vant/area-data";
import { adSignUp, sendMessege, verifySnsCode } from "@/api/common.js";
import { nameReg, phoneReg } from "@/utils/validateReg.js";
import eventTrack from "@/mixins/eventTrack";
import { randomString } from "@/utils";
const initForm = () => {
  return {
    name: "",
    telphone: "",
    codes: "",
    fy_location: "",
  };
};

export default {
  props: {
    formName: {
      type: String,
      default: "",
    },
    round: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "慕思好眠心愿节",
    },
    activityUrl: {
      type: String,
      default: "",
    },
  },
  mixins: [eventTrack],
  data() {
    return {
      lotteryNum: 0,
      signUpNum: 0,
      form: initForm(),
      checked: false,
      areaList,
      showArea: false,
      show: false,
      loading: false,
      smsText: "发送验证码",
      isSend: false,
      num: 60,
      timer: null,
      scrollTop: 0,
    };
  },
  methods: {
    goSignUp() {
      document.getElementById("form").scrollIntoView();
    },
    goScanCode() {
      if (this.lotteryNum <= 0) {
        this.$toast("请先报名");
        return;
      }
      this.$router.push("/1212/scanCode");
    },
    sendSms() {
      if (!this.form.telphone) {
        this.$toast("手机号码必填");
        return;
      }
      if (!phoneReg.test(this.form.telphone)) {
        this.$toast("手机号码格式不正确");
        return;
      }
      if (!this.isSend) {
        const params = {
          project: "慕思好眠心愿节", // 调用项目：CRM
          phone: this.form.telphone, // 调用电话：多个时用分号隔开，上限500个
          sender: 8822072204468,
          signName: "慕思", // 签名：慕思
          tempCode: "010bffe48c3d46d7bf837fa3eb084134", // 模板code: SMS_182541596
          operType: "CAPTCHA", // 操作类型：CAPTCHA 验证码类短信、NOTE 通知类短信
          tempParam: "{}", // 模板中的变量，json字符串，验证码code非空时，直接进行验证码处理，验证码code为空时，由接口自动生成
          mhzTime: 1, // 验证码发送频率时长，范围：1分钟~2分钟，默认：1分钟
          validTime: 5, // 验证码有效时间，范围：5分钟~30分钟，默认：5分钟
        };
        this.isSend = true;
        this.timer = setInterval(() => {
          if (this.num > 0) {
            this.num--;
          } else {
            clearInterval(this.timer);
            this.isSend = false;
            this.num = 60;
          }
        }, 1000);
        sendMessege(params).then((res) => {
          if (res.code == 0) {
            this.$toast("发送成功");
            return;
          }
          this.$toast(res.msg);
          clearInterval(this.timer);
          this.isSend = false;
          this.num = 60;
        });
      }
    },
    async onSubmit() {
      if (!this.form.name) {
        this.$toast("姓名必填");
        return;
      }
      if (!this.form.telphone) {
        this.$toast("手机号码必填");
        return;
      }
      if (!this.form.codes) {
        this.$toast("验证码必填");
        return;
      }
      if (!this.form.fy_location) {
        this.$toast("所在地区必填");
        return;
      }
      if (!nameReg.test(this.form.name)) {
        this.$toast("姓名格式不正确");
        return;
      }
      if (!phoneReg.test(this.form.telphone)) {
        this.$toast("手机号码格式不正确");
        return;
      }

      try {
        const { code, msg } = await verifySnsCode({
          phone: this.form.telphone,
          verifyCode: this.form.codes,
        });
        if (code != 0) {
          this.$toast(msg);
          return;
        }
      } catch (err) {
        return;
      }
      let location = this.form.fy_location.split("/");
      let province = location[0] || "";
      let city = location[1] || "";
      let area = location[2] || "";
      let data = {
        ad_id: this.$route.query.confId, //专题页id
        external_url: window.location.href, //投放url
        gender: "未知", //性别：男/女/未知
        create_time: +new Date() + "", //创建时间
        telphone: this.form.telphone, //手机号码
        ad_name: this.title, // 专题页名称
        name: this.form.name, //姓名
        province, //省
        city, //城市
        area, //地区
        id: randomString(18), //线索id
      };
      this.loading = true;
      adSignUp(data)
        .then((res) => {
          if (res.code == "0") {
            this.$toast("报名成功");
            this.signUpNum = 1;
            this.lotteryNum = 1;
            clearInterval(this.timer);
            this.isSend = false;
            this.num = 60;
            this.form = initForm();
            return;
          }
          this.$toast("报名失败");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onConfirm(values) {
      let strArr = [];
      values.map((item) => {
        strArr.push(item.name);
      });
      this.form.fy_location = strArr.join("/");
      this.showArea = false;

      this.InputBlur({
        input_Label: "所在地区",
        formpage_name: this.formName,
        input_value: this.form.fy_location,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep {
  .van-cell {
    background-color: #fff;
    border: 1px solid #ccc;
    border-radius: 5px;
  }
  .van-field__button {
    .van-button--info {
      background-image: linear-gradient(to right, #fde7d1, #f9d3ab);
      border: none;
    }
  }
  .bg-btn {
    .van-button--info {
      width: 100%;
      height: 100%;
      background-color: transparent;
      border: none;
    }
  }
}
.wrapper {
  width: 100%;
  min-height: 100vh;
  box-sizing: border-box;
  .signUp {
    width: 100%;
    height: 43px;
    background: url("../../assets/20231212/m_3.jpg") 100% 100% no-repeat;
    background-size: cover;
  }
  .form {
    width: 100%;
    min-height: 410px;
    background: url("../../assets/20231212/m_4.jpg") 100% 100% no-repeat;
    background-size: contain;
    padding: 0 25px;
    box-sizing: border-box;
    .label {
      padding: 10px 0;
      font-size: 15px;
    }
    .bg-btn {
      width: 320px;
      height: 53px;
      background: url("../../assets/20231212/btn_3.png") 100% 100% no-repeat;
      background-size: contain;
      margin-top: 10px;
    }
  }
  .model {
    display: block;
    width: 100%;
  }
  .numberModel {
    width: 100%;
    height: 310px;
    background: url("../../assets/20231212/m_2.jpg") 100% 100% no-repeat;
    background-size: contain;
    box-sizing: border-box;
    padding-top: 35px;
    .item {
      width: 316px;
      height: 80px;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      font-size: 12px;
      color: #fff;
      margin: 0 auto;
      border-bottom: 1px solid #52459f;
      .icon {
        width: 42px;
      }
      .btnGroup {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        flex-grow: 1;
        .number {
          margin-left: 18px;
          div {
            margin-top: 13px;
            color: #fbdab8;
            font-size: 24px;
            span {
              padding-left: 5px;
            }
          }
          span {
            color: #fff;
            font-size: 12px;
          }
        }
        .btn {
          width: 111px;
          height: 38px;
          background: url("../../assets/20231212/btn_1.png") 100% 100% no-repeat;
          background-size: contain;
        }
        .btn_2 {
          background-image: url("../../assets/20231212/btn_2.png");
        }
      }
    }
  }
}
</style>
